import React, { SyntheticEvent, FC, useState } from 'react';

import { Dialog, DialogContent, DialogActions, CircularProgress, DialogTitle } from '@material-ui/core';

import { CloseButton } from 'components/common/commonComponentsTSX';

import { makeStyles } from '@material-ui/core/styles';

import { UserThemeContext } from '../../../../theme/context';

import { Box, Button, Checkbox } from '@material-ui/core';

import { useDataProvider, useNotify } from 'react-admin';

import { CustomDataProvider, IErrorPromise } from './types';

export type KEnquete = {
	id: string;
	condominio: number;
	titulo: string;
	inicio_enquete: string;
	fim_enquete: string;
	quem_pode_responder: string;
	permitir_voto_inadimplente: boolean;
};

type ModalDetalhesEnqueteProps = {
	enqueteData: KEnquete;
	open: boolean;
	onClose: (event: SyntheticEvent<boolean>, reason: 'backdropClick' | 'escapeKeyDown') => void;
	tipoRelatorio: { name: string; action: string };
	opcoesImpressao: {
		imprimirAgruparPorPessoa: boolean;
		imprimirInadimplencia: boolean;
		imprimirUnidadesNaoVotaram: boolean;
		imprimirRespostaMorador: boolean;
	};
	setOpcoesImpressao: React.Dispatch<
		React.SetStateAction<{
			imprimirAgruparPorPessoa: boolean;
			imprimirInadimplencia: boolean;
			imprimirUnidadesNaoVotaram: boolean;
			imprimirRespostaMorador: boolean;
		}>
	>;
};

const ModalDetalhesEnquete: FC<ModalDetalhesEnqueteProps> = (props) => {
	const [loading] = useState(false);
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
		props.setOpcoesImpressao({
			...props.opcoesImpressao,
			[e.target.id]: e.target.checked,
		});

	const { theme } = React.useContext(UserThemeContext);
	const dataProvider = useDataProvider() as CustomDataProvider;
	const notify = useNotify();

	const useStyles = makeStyles((theme) => ({
		progressBar: {
			backgroundColor: '#2F345D',
		},
		emptyBar: {
			backgroundColor: '#7481a5',
		},

		progressLabel: {
			position: 'absolute',
			padding: '12px 0',
			zIndex: 1,
			display: 'flex',
			gap: '410px',
		},
		checkboxLabel: {
			display: 'block',
			cursor: 'pointer',
		},
	}));
	const classes = useStyles();

	const handleClick = (e: any, tipoSaida: string) => {
		dataProvider
			.gerarRelatorio('relatorios', {
				...props.enqueteData,
				tipo_saida: tipoSaida,
				opcoesImpressao: props.opcoesImpressao,
				tipoRelatorio: 'detalhes_enquete',
			})
			.then(({ data }: { data: { success: string } }) =>
				notify(tipoSaida === 'enviar' ? data?.success : 'Relatório gerado com sucesso!')
			)
			.catch((e: IErrorPromise) => {
				if (e?.response?.data instanceof Blob) {
					e.response.data.text().then((text) => {
						const data_obj = JSON.parse(text) as object;
						notify(
							Object.values(data_obj || {})[0] || ['Erro inesperado, tente recarregar a página'],
							'warning'
						);
					});
				} else {
					notify(
						Object.values(e?.response?.data || {})[0] || ['Erro inesperado, tente recarregar a página'],
						'warning'
					);
				}
				if ([400, 401, 403].includes(e?.response?.status)) return Promise.reject(e);
			});
	};

	return (
		<Dialog
			open={props.open}
			onClose={props.onClose}
			fullWidth
			PaperProps={{
				style: {
					minWidth: '30vw',
					position: 'relative',
				},
			}}
		>
			<div
				style={{
					marginTop: '12px',
					fontSize: '18px',
					display: 'flex',
				}}
			>
				<DialogTitle>Detalhes da Enquete</DialogTitle>
			</div>
			<div style={{ height: '1px', backgroundColor: theme === 'dark' ? 'white' : 'black' }}></div>
			<DialogContent>
				<div style={{ marginTop: '12px', fontSize: '18px' }}>
					<span style={{ paddingRight: '5px' }}>Opções de Impressão</span>
				</div>
				<Box style={{ marginTop: '10px' }}>
					<label htmlFor='imprimirAgruparPorPessoa' className={classes.checkboxLabel}>
						<Checkbox
							id='imprimirAgruparPorPessoa'
							checked={props.opcoesImpressao.imprimirAgruparPorPessoa}
							onChange={handleChange}
						/>
						Imprimir e agrupar por pessoa
					</label>
					<label htmlFor='imprimirInadimplencia' className={classes.checkboxLabel}>
						<Checkbox
							id='imprimirInadimplencia'
							checked={props.opcoesImpressao.imprimirInadimplencia}
							onChange={handleChange}
						/>
						Imprimir inadimplência
					</label>
					<label htmlFor='imprimirUnidadesNaoVotaram' className={classes.checkboxLabel}>
						<Checkbox
							id='imprimirUnidadesNaoVotaram'
							checked={props.opcoesImpressao.imprimirUnidadesNaoVotaram}
							onChange={handleChange}
						/>
						Imprimir unidades que não votaram
					</label>
					<label htmlFor='imprimirRespostaMorador' className={classes.checkboxLabel}>
						<Checkbox
							id='imprimirRespostaMorador'
							checked={props.opcoesImpressao.imprimirRespostaMorador}
							onChange={handleChange}
						/>
						Imprimir resposta do morador
					</label>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button color='primary' variant='outlined' onClick={(e) => handleClick(e, 'visualizar')}>
					Visualizar
				</Button>
				<Button color='primary' variant='outlined' onClick={(e) => handleClick(e, 'pdf')}>
					Baixar PDF
				</Button>
				<CloseButton onClick={props.onClose} size='small'>
					{(loading && <CircularProgress size={20} />) || 'Voltar'}
				</CloseButton>
			</DialogActions>
		</Dialog>
	);
};

export default ModalDetalhesEnquete;
